
<template lang="">
    <UserLayout ref="userLayout"  pageTitle="Gestione utenti">
      <template #page-content="props"> 
              <!-- <v-card
                  class="form-card" 
                  outlined 
                  >  -->
                  <FrmManageUsers   @currentUserChaged="CurrentUserChanged"></FrmManageUsers>

              <!-- </v-card> -->
      </template>
  </UserLayout>  
</template>
<script>
import UserLayout from "../layout/UserLayout"; 
import FrmManageUsers from "../components/Management/FrmManageUsers";
import SessionHelper from "../utils/SessionHelper";
export default {
  mounted(){
    
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
  },
  components: {
    FrmManageUsers,
    UserLayout,
  },
  methods:{
    CurrentUserChanged(user){
      this.$refs.userLayout.CurrentUserChanged(user);
    }
  }
};
</script>
<style lang="">
</style> 